import { render, staticRenderFns } from "./GenericElement.vue?vue&type=template&id=e2a73a3a&scoped=true&"
import script from "./GenericElement.vue?vue&type=script&lang=js&"
export * from "./GenericElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a73a3a",
  null
  
)

export default component.exports